// Written by runFormChangeHandlerLoop, useFormChangeTracker (on enqueue) and resetSaveQueues.
// Module scope like the queue registry: a snapshot can land after the form that sent the
// value re-rendered or remounted, and ownership must still know what the server was given.
const sentValues = new Map<string, Map<string, unknown>>();

const NOTHING_SENT: ReadonlyMap<string, unknown> = new Map();

/** Records the value a request is about to send for `fieldId`. */
export const markSentValue = (
  saveKey: string,
  fieldId: string,
  value: unknown,
): void => {
  let forKey = sentValues.get(saveKey);
  if (!forKey) {
    forKey = new Map();
    sentValues.set(saveKey, forKey);
  }
  forKey.set(fieldId, value);
};

/** Drops the mark of a request that failed, so its field stays client-owned. */
export const unmarkSentValue = (saveKey: string, fieldId: string): void => {
  sentValues.get(saveKey)?.delete(fieldId);
};

/** Drops every mark for one form; a new batch starts from nothing sent. */
export const forgetSentValues = (saveKey: string): void => {
  sentValues.delete(saveKey);
};

/** The values the current batch has sent for one form, by field id. */
export const getSentValues = (saveKey: string): ReadonlyMap<string, unknown> =>
  sentValues.get(saveKey) ?? NOTHING_SENT;

/** Drops every mark for every form. */
export const clearSentValues = (): void => {
  sentValues.clear();
};
